import { attr } from '@ember-data/model';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import MoneyProto from '@square/dashboard-data/models/squareup/common/money-proto';
export default EmberDataBaseModel.extend({
  itemName: attr('string'),
  variationName: attr('string'),
  gtin: attr('string'),
  imageUrls: attr('array'),
  categoryHints: attr('array'),
  suggestedPrice: attr(MoneyProto)
});